import * as React from "react";

const SvgEmailNotification = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			fill={props.fill || "#666666"}
			d="M4 21C3.45 21 2.979 20.804 2.588 20.413A1.93 1.93 0 0 1 2 19V7q0-.825.588-1.412A1.93 1.93 0 0 1 4 5h9q.424 0 .712.288Q14 5.575 14 6q0 .424-.288.712A.97.97 0 0 1 13 7H4v12h16v-7q0-.424.288-.712A.97.97 0 0 1 21 11q.424 0 .712.288Q22 11.575 22 12v7q0 .824-.588 1.413A1.93 1.93 0 0 1 20 21zM12 12l3.225-2q.35-.225.663-.112.312.112.487.387.175.275.125.6-.05.325-.4.55l-3.575 2.25a1 1 0 0 1-.525.15 1 1 0 0 1-.525-.15L4 9V7zm4.875-3.875A2.9 2.9 0 0 1 16 6q0-1.25.875-2.125A2.9 2.9 0 0 1 19 3q1.25 0 2.125.875T22 6t-.875 2.125A2.9 2.9 0 0 1 19 9a2.9 2.9 0 0 1-2.125-.875"
		/>
	</svg>
);

export default SvgEmailNotification;